import client from '../../client';

const CONTACTS = {
  getContacts(params) {
    return client.get(`/buyers/${client.customerId()}/contacts`, params);
  },
}

export default CONTACTS;
